import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets(){
    return [];
  }

  initialize(){
let t = this;
    if (t.data.has('button-disable-with')){
      t.element.addEventListener('ajax:before', function(){
        t.data.set('original-html', t.element.innerHTML) ;
        t.element.innerHTML = t.data.get('button-disable-with');

      })

    }
  }

  new(e){
if (this.data.has('original-html')) this.element.innerHTML = this.data.get('original-html');
    this.renderForm(e.detail[0].response);

    $("#" + this.data.get("modal-id")).modal('show');
  }

  onSubmitFail(e){
    this.renderForm(e.detail[2].response);
  }

  renderForm(response){
    let modal = document.getElementById(this.data.get("modal-id"));
    modal.querySelector('.modal-body').innerHTML = response;
  }

}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/modal_form_controller.js